 

import { APP_INITIALIZER } from '@angular/core';
import { AppConfigService } from './Services/AppConfigService';
import { BrowserModule } from '@angular/platform-browser'; 
import { NgModule, CUSTOM_ELEMENTS_SCHEMA } from '@angular/core';
import { AppRoutingModule } from './app-routing.module';  
import { AppComponent }  from './app.component';    
import { EventsComponent }  from './events/events.component'; 
import { HttpClientModule, HTTP_INTERCEPTORS } from '@angular/common/http';
import { AuthTokenInterceptor } from './guards/auth-token.interceptor';
  
import { DatePipe } from '@angular/common';  
import { FormsModule } from '@angular/forms';  
import { CommonModule, CurrencyPipe} from '@angular/common'; 
import { ReactiveFormsModule } from '@angular/forms';

// import * as MaterialModules from '@angular/material';

//  import {
//   MatPaginatorModule,
//   MatProgressSpinnerModule,
//   MatMenuModule,
//   MatSortModule,
//   MatTableModule,
//   MatIconModule, MatToolbarModule,
//   MatCardModule, 
//   MatFormFieldModule } from "@angular/material";

import { MatAutocompleteModule } from '@angular/material/autocomplete';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { MatNativeDateModule } from '@angular/material/core';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { MatRadioModule } from '@angular/material/radio';
import { MatSelectModule } from '@angular/material/select';
import { MatSliderModule } from '@angular/material/slider';
import { MatSlideToggleModule } from '@angular/material/slide-toggle';
// Material Navigation
import { MatMenuModule } from '@angular/material/menu';
import { MatSidenavModule } from '@angular/material/sidenav';
import { MatToolbarModule } from '@angular/material/toolbar';
// Material Layout
import { MatCardModule } from '@angular/material/card';
import { MatDividerModule } from '@angular/material/divider';
import { MatExpansionModule } from '@angular/material/expansion';
import { MatGridListModule } from '@angular/material/grid-list';
import { MatListModule } from '@angular/material/list';
import { MatStepperModule } from '@angular/material/stepper';
import { MatTabsModule } from '@angular/material/tabs';
import { MatTreeModule } from '@angular/material/tree';
// Material Buttons & Indicators
import { MatButtonModule } from '@angular/material/button';
import { MatButtonToggleModule } from '@angular/material/button-toggle';
import { MatBadgeModule } from '@angular/material/badge';
import { MatChipsModule } from '@angular/material/chips';
import { MatIconModule } from '@angular/material/icon';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { MatProgressBarModule } from '@angular/material/progress-bar';
import { MatRippleModule } from '@angular/material/core';
// Material Popups & Modals
import { MatBottomSheetModule } from '@angular/material/bottom-sheet';
import { MatDialogModule } from '@angular/material/dialog';
import { MatSnackBarModule } from '@angular/material/snack-bar';
import { MatTooltipModule } from '@angular/material/tooltip';
// Material Data tables
import { MatPaginatorModule } from '@angular/material/paginator';
import { MatSortModule } from '@angular/material/sort';
import { MatTableModule } from '@angular/material/table';

import { FlexLayoutModule } from '@angular/flex-layout';






import { FooterComponent } from './footer/footer.component'; 
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';   
//import { DxSelectBoxModule,DxCheckBoxModule,  DxTextAreaModule,  DxFormModule,DxButtonModule,  DxNumberBoxModule,DxDateBoxModule, DxDrawerModule,  DxListModule,  DxRadioGroupModule,  DxToolbarModule} from 'devextreme-angular';
 
import { NoAccessComponent } from './no-access/no-access.component';  
import { AdminComponent } from './admin/admin.component';  
import { UserService } from './user.service';  
import { DragDropModule,moveItemInArray  } from '@angular/cdk/drag-drop';
import { FilterPipe} from './filter.pipe';  
import { SafeHtmlPipe} from './safeHtml.pipe';  
import { MyaccountComponent } from './myaccount/myaccount.component'; 
import { PrivacypolicyComponent } from './privacypolicy/privacypolicy.component';
import { ContactusComponent } from './contactus/contactus.component'; 
import { AboutusComponent } from './aboutus/aboutus.component';    
   
import { NavigationComponent } from './navigation/navigation.component';
import { BottomcardsComponent } from './bottomcards/bottomcards.component';
import { PlansComponent } from './plans/plans.component';
import { PlanDetailComponent } from './plan-detail/plan-detail.component';
import { DistributorGridComponent } from './distributor-grid/distributor-grid.component';
import { DistributorFormComponent } from './distributor-form/distributor-form.component';
import { MaterialsGridComponent } from './materials-grid/materials-grid.component';
import { MaterialFormComponent } from './material-form/material-form.component';
import { HomeComponent } from './home/home.component'; 
import { NgxDatatableModule } from '@swimlane/ngx-datatable';
import { EquipmentGridComponent } from './equipment-grid/equipment-grid.component';
import { EquipmentAddComponent } from './equipment-add/equipment-add.component';
import { EquipmentEditComponent } from './equipment-edit/equipment-edit.component';
import { ManufacturerGridComponent } from './manufacturer-grid/manufacturer-grid.component';
import { ManufacturerAddComponent } from './manufacturer-add/manufacturer-add.component';
import { ManufacturerEditComponent } from './manufacturer-edit/manufacturer-edit.component';
import { ContractorGridComponent } from './contractor/contractor-grid/contractor-grid.component';
import { ContractorAddComponent } from './contractor/contractor-add/contractor-add.component';
import { ContractorEditComponent } from './contractor/contractor-edit/contractor-edit.component';
import { ProjectBidGridComponent } from './project-bid-grid/project-bid-grid.component';
import { ProjectBidAddComponent } from './project-bid-add/project-bid-add.component';
import { ProjectBidEditComponent } from './project-bid-edit/project-bid-edit.component';
import { ProjectGridComponent } from './project/project-grid/project-grid.component';
import { ProjectAddComponent } from './project/project-add/project-add.component';
import { ProjectEditComponent } from './project/project-edit/project-edit.component';
import { ProjectTaskGridComponent } from './project/project-task-grid/project-task-grid.component';
import { ProjectTaskAddComponent } from './project/project-task-add/project-task-add.component';
import { ProjectTaskEditComponent } from './project/project-task-edit/project-task-edit.component';
import { ProjectMaterialComponent } from './project/project-material/project-material.component'; 
import { ProjectImageComponent } from './project/project-image/project-image.component';
import { ProjectDrawingComponent } from './project/project-drawing/project-drawing.component';
import { ProjectDrawingUploadComponent } from './project/project-drawing-upload/project-drawing-upload.component';
import { ProjectImageUploadComponent } from './project/project-image-upload/project-image-upload.component';
import { ProjectMaterialAddComponent } from './project/project-material-add/project-material-add.component';
import { ProjectEquipmentAddComponent } from './project/project-equipment-add/project-equipment-add.component';
import { ProjectEquipmentGridComponent } from './project/project-equipment-grid/project-equipment-grid.component';
import { SortByOrderPipe } from './sort-by-order.pipe';
import { ProjectImagePopupComponent } from './project/project-image-popup/project-image-popup.component';
import { LeftMenuComponent } from './left-menu/left-menu.component';
import { MainContentComponent } from './main-content/main-content.component';
import { PhoneFilterPipe } from './phone-filter.pipe';
import { ButtonsComponent } from './buttons/buttons.component';
import { HeadlineComponent } from './headline/headline.component';
import { LazyLoadImageModule } from 'ng-lazyload-image'; 
import { QuestionareListComponent } from './questionare-list/questionare-list.component';
import { AddQuestionareComponent } from './add-questionare/add-questionare.component';
import { CsvUploadComponent } from './csv-upload/csv-upload.component';
import { MytasksComponent } from './mytasks/mytasks.component';
import { SmartsheetComponent } from './smartsheet/smartsheet.component';
import { ProjectContractorsComponent } from './project/project-contractors/project-contractors.component';
import { ProjectContractorsAddComponent } from './project/project-contractors-add/project-contractors-add.component';
import { ContractorImageUploadComponent } from './contractor/contractor-image-upload/contractor-image-upload.component';
import { ProviderDashboardComponent } from './components/provider-dashboard/provider-dashboard.component';
import { AuthComponent } from './components/auth/auth.component';
import { CustomerDashboardComponent } from './components/customer-dashboard/customer-dashboard.component';
import { UserCreateComponent } from './components/user-create/user-create.component';
import { ProviderServicesComponent } from './components/provider-services/provider-services.component';
import { NotesComponent } from './notes/notes.component';
import { AppointmentComponent } from './appointment/appointment.component';  
import { ProjectScheduleComponent } from './project-schedule/project-schedule.component';
import { BrowseServicesComponent } from './browse-services/browse-services.component';
import { EquipmentRentalsComponent } from './equipment-rentals/equipment-rentals.component';
import { ProjectLaborComponent } from './project/project-labor/project-labor.component';
import { CurrencyInputDirective } from './directives/currency-input.directive';
import { PaymentsComponent } from './components/payments/payments.component';
import { CheckoutComponent } from './components/checkout/checkout.component';
import { ServiceHistoryComponent } from './components/service-history/service-history.component';
import { AdminUsersComponent } from './admin-users/admin-users.component';
import { BecomeProviderComponent } from './become-provider/become-provider.component';
import { EditAccountComponent } from './components/edit-account/edit-account.component';
import { DesignListComponent } from './design-list/design-list.component';
import { DesignEditorComponent } from './design-editor/design-editor.component';
import { AgentCatalogComponent } from './agent-catalog/agent-catalog.component';
import { ProjectDailyReportComponent } from './project/project-daily-report/project-daily-report.component';
import { ProjectRfiComponent } from './project/project-rfi/project-rfi.component';
import { ResourcePlanningComponent } from './resource-planning/resource-planning.component';
import { GetBidComponent } from './get-bid/get-bid.component';
import { AdminProjectTypesComponent } from './admin-project-types/admin-project-types.component';
import { CollectPaymentComponent } from './components/collect-payment/collect-payment.component';
import { ContractorPayoutsComponent } from './components/contractor-payouts/contractor-payouts.component';

@NgModule({
  declarations: [
    AppComponent,  PhoneFilterPipe,  SafeHtmlPipe,
    FooterComponent, FilterPipe,AdminComponent, HeadlineComponent,
     NoAccessComponent,  EventsComponent, FilterPipe, MyaccountComponent, PrivacypolicyComponent,
       ContactusComponent,  AboutusComponent, NavigationComponent, BottomcardsComponent, PlansComponent, PlanDetailComponent,
        DistributorGridComponent, DistributorFormComponent, MaterialsGridComponent, MaterialFormComponent, 
        HomeComponent, EquipmentGridComponent, EquipmentAddComponent,  
        EquipmentEditComponent, ManufacturerGridComponent, ManufacturerAddComponent, 
        ManufacturerEditComponent, ContractorGridComponent, ContractorAddComponent, 
        ContractorEditComponent, ProjectBidGridComponent, ProjectBidAddComponent, 
        ProjectBidEditComponent, ProjectGridComponent, ProjectAddComponent, ProjectEditComponent, ProjectTaskGridComponent,
         ProjectTaskAddComponent, ProjectTaskEditComponent, ProjectMaterialComponent,  ProjectImageComponent, ProjectDrawingComponent, 
         ProjectDrawingUploadComponent, 
         ProjectImageUploadComponent, ProjectMaterialAddComponent, ProjectEquipmentAddComponent, ProjectEquipmentGridComponent, 
         SortByOrderPipe, ProjectImagePopupComponent, LeftMenuComponent, MainContentComponent, PhoneFilterPipe, ButtonsComponent, 
         HeadlineComponent, QuestionareListComponent, AddQuestionareComponent, CsvUploadComponent, MytasksComponent, SmartsheetComponent,
           ProjectContractorsComponent, ProjectContractorsAddComponent, ContractorImageUploadComponent, ProviderDashboardComponent, 
            AuthComponent, CustomerDashboardComponent, UserCreateComponent, ProviderServicesComponent, NotesComponent, AppointmentComponent, ProjectScheduleComponent, BrowseServicesComponent, EquipmentRentalsComponent, ProjectLaborComponent, PaymentsComponent, CheckoutComponent, ServiceHistoryComponent, AdminUsersComponent,
    BecomeProviderComponent, EditAccountComponent,
    DesignListComponent, DesignEditorComponent,
    AgentCatalogComponent,
    ProjectDailyReportComponent, ProjectRfiComponent, ResourcePlanningComponent, GetBidComponent, AdminProjectTypesComponent,
    CollectPaymentComponent, ContractorPayoutsComponent,
    CurrencyInputDirective ],
  

  imports: [CommonModule,AppRoutingModule,LazyLoadImageModule,ReactiveFormsModule,
    BrowserModule,
    AppRoutingModule,
    FlexLayoutModule,
    HttpClientModule,  MatIconModule,
    MatAutocompleteModule,
    MatCheckboxModule,
    MatDatepickerModule,
    MatNativeDateModule,
    MatFormFieldModule,
    MatInputModule,
    MatRadioModule,
    MatSelectModule,
    MatSliderModule,
    MatSlideToggleModule,
    MatMenuModule,
    MatSidenavModule,
    MatToolbarModule,
    MatCardModule,
    MatDividerModule,
    MatExpansionModule,
    MatGridListModule,
    MatListModule,
    MatStepperModule,
    MatTabsModule,
    MatTreeModule,
    MatButtonModule,
    MatButtonToggleModule,
    MatBadgeModule,
    MatChipsModule,
    MatIconModule,
    MatProgressSpinnerModule,
    MatProgressBarModule,
    MatRippleModule,
    MatBottomSheetModule,
    MatDialogModule,
    MatSnackBarModule,
    MatTooltipModule,
    MatPaginatorModule,
    MatSortModule,
    MatTableModule,
    BrowserAnimationsModule,
    FormsModule,
    BrowserAnimationsModule, NgxDatatableModule 
  ],
 


  exports: [
    MatAutocompleteModule,
    MatCheckboxModule,
    MatDatepickerModule,
    MatNativeDateModule,
    MatFormFieldModule,
    MatInputModule,
    MatRadioModule,
    MatSelectModule,
    MatSliderModule,
    MatSlideToggleModule,
    MatMenuModule,
    MatSidenavModule,
    MatToolbarModule,
    MatCardModule,
    MatDividerModule,
    MatExpansionModule,
    MatGridListModule,
    MatListModule,
    MatStepperModule,
    MatTabsModule,
    MatTreeModule,
    MatButtonModule,
    MatButtonToggleModule,
    MatBadgeModule,
    MatChipsModule,
    MatIconModule,
    MatProgressSpinnerModule,
    MatProgressBarModule,
    MatRippleModule,
    MatBottomSheetModule,
    MatDialogModule,
    MatSnackBarModule,
    MatTooltipModule,
    MatPaginatorModule,
    MatSortModule,
    MatTableModule 
  ], 
  schemas: [ CUSTOM_ELEMENTS_SCHEMA ],
  providers: [UserService,CurrencyPipe,DatePipe,
    { provide: HTTP_INTERCEPTORS, useClass: AuthTokenInterceptor, multi: true },
    {
    provide: APP_INITIALIZER,
      multi: true,
      deps: [AppConfigService],
      useFactory: (appConfigService: AppConfigService) => {
        return () => {
          //Make sure to return a promise!
          return appConfigService.loadAppConfig();
        };
      }
  }],
  bootstrap: [AppComponent]
  
})
export class AppModule { }
